if ( $('#projects').length ) {

  var adminAjax = $('section#filters').attr('data-admin-ajax');
  var selectedProjects;
  var expandFilters=false;

  //--------------------------------------------------------------------------------
  //- filtering engine
  //--------------------------------------------------------------------------------

  /**
  * Load selected projects cards with AJAX
  * @param countries
  * @param regions
  * @param sectors
  * @param paged
  */
  function load_cards(countries, regions, sectors, paged){
    return $.post(
      adminAjax,
      {
        action : 'load_projects_cards',
        countries: countries,
        regions: regions,
        sectors: sectors,
        paged: paged
      },
      'html'
    )
    .done(function(cards){
      $('.projects-list > div').html(cards);
      initProjectsList();
    });
  }

  /**
  * populate 'selectedCountries' array with selected countries
  * return array
  */
  function getCountriesSelection() {
    var selectedCountries = [];

    $("#countries a.checked").each(function () {
      var value = $(this).attr('id');
      selectedCountries.push(value);
    });

    setApplyButtonStatus(selectedCountries);
    return selectedCountries;
  }

  /**
  * populate 'selectedRegions' array with selected regions
  * @param selectedCountries =array
  * return array
  */
  function getRegionsSelection(selectedCountries){
    var selectedRegions = [];

    $.each(selectedCountries, function (key, country) {
      $('.selections:visible .regions .country ul.' + country + ' input').each(function () {
        var value = $(this).prop('checked');
        var region = $(this).attr('id');
        if(value == true){
          selectedRegions.push(region);
        }
        //- clone checkboxe selection to the both menus: mobile/desk
        $('.selections .regions .country ul.' + country + ' input.' + region).prop('checked', value);
      });
    });

    setApplyButtonStatus(selectedRegions);
    return selectedRegions;
  }

  /**
  * populate 'selectedSectors' array with selected sectors
  * @param selectedCountries =array
  * return array
  */
  function getSectorsSelection() {
    var selectedSectors = [];
    $('.selections:visible .sectors input').each(function () {
      var value = $(this).prop('checked');
      var sector = $(this).attr('id');
      if(value === true && selectedSectors.indexOf(sector) < 0) {
        selectedSectors.push(sector);
      }
      //- clone checkboxe selection to the both menus: mobile/desk
      $('.selections .sectors input.' + sector).prop('checked', value);
    });

    setApplyButtonStatus(selectedSectors);
    return selectedSectors;
  }

  /**
  * update regions select according to countries selection
  * @param countries = array
  * return array
  */
  function updateRegions(selectedCountries) {
    var selectedRegions = [];
    var checkRegionsSelection;
    //- when country was unselected, unselect all its regions
    $.each(countriesList, function (key, country) {
      if($.inArray(country, selectedCountries) == -1) {
        $('.regions .country ul.' + country + ' input').prop('checked', false);
      }
    });
    //- set selected regions list
    $.each(selectedCountries, function (key, country) {
      checkRegionsSelection = getRegionsSelection([country]);
      //- if selected country has no selected regions (= country's previous status was unselected)
      if(checkRegionsSelection.length == 0){
        $('.regions .country ul.' + country + ' input').prop('checked', true);
        checkRegionsSelection = getRegionsSelection([country]);
      }
      //- and then update selection
      $.each(checkRegionsSelection, function (key, region) {
          selectedRegions.push(region);
      });
    });
    return selectedRegions;
  }

  /**
  * update sectors select according to countries / regions selections
  * @param selectedCountries = array
  * @param selectedRegions = array
  * return array
  */
  function updateSectors(selectedCountries, selectedRegions){
    var selectedSectors = [];
    $('.sectors input').prop('checked', false);
    $('.sectors input').prop('disabled', true);

    $.each(selectedCountries, function (key, country) {
      $.each(selectedRegions, function (key, region) {
        $.each(sortedProjects[country][region], function (sector, value) {
          if ((sector != '') && (selectedSectors.indexOf(sector) < 0)) {
            selectedSectors.push(sector);
            $('.sectors input#' + sector).prop('checked', true);
            $('.sectors input#' + sector).prop('disabled', false);
          }
        });
      });
    });
    return selectedSectors;
  }

  /**
  * BUILD the filtered projects list
  * update projects markers in gmaps
  * update projects cards with AJAX
  * @param selectedCountries = array
  * @param selectedRegions = array
  * @param selectedSectors = array
  * return array
  */
  function getSelectedProjects(selectedCountries, selectedRegions, selectedSectors, paged){
    paged = paged || 1;
    selectedProjects={};
    //- when only countries filters are selected reset regions/sectors :
    //- to fetch ALL the projects with the WP query,
    //- including the ones who miss these params
    if(selectedRegions){
      var regions = (selectedRegions.indexOf('') > -1) ? null : selectedRegions;
      var sectors = (selectedRegions.indexOf('') > -1) ? null : selectedSectors;
    }
    //- build selectedProjects list
    $.each(selectedCountries, function (key, country) {
      $.each(selectedRegions, function (key, region) {
        //- if region exists in this country...
        if (sortedProjects[country][region]) {
        $.each(selectedSectors, function (key, sector) {
          //- if sector exists fot this country/region selection
          if (sortedProjects[country][region][sector]){
            $.each(sortedProjects[country][region][sector], function (id, project) {
              selectedProjects[id] = project;
            });
          }
        });
      }
      });
    });
    //- ajax call : load cards
    $.when(load_cards(selectedCountries, regions, sectors, paged))
    .then(function(){
      //- when using filters: refresh map with the new projects' markers
      if(paged == 1 && !$.isEmptyObject(selectedProjects)){
        load_markers(selectedProjects);
      }
      //- else when just using pagination
      else{
        setMarkersColor(currentPostsIds);
        setMarkersColor(onlinePostsIds);
      }
    });

    return selectedProjects;
  }

  //------------------------------------------------------------------------------------------
  //- filter menu interactivity / behaviour
  //------------------------------------------------------------------------------------------

  //- fix a flexbox bug with column wrap width: https://bit.ly/2FwgoTD
  function forceFlexWidthtoFitContent(container){
    $(container).each(function () {
      //- set last child min width equal to bigger child width
      //- we need this to be able to set the proper container width
      var biggerChildWidth = 0;
      $(this).children().each(function () {
        biggerChildWidth = $(this).outerWidth(true) > biggerChildWidth ? $(this).outerWidth(true) : biggerChildWidth;
      });
      var lastChild = $(this).children().last();
      lastChild.find('label').width(biggerChildWidth);
      //-set the flex container width to fit content
      var newContainerWidth = lastChild.position().left - $(this).position().left + lastChild.width();
      $(this).width(newContainerWidth);
    });
  }

  function expandFilterMenu(){
    $('#filters').addClass('shadow');
    setTimeout(function() {
      $('#select').addClass('expand opacity');
      $('#expandFilters img').addClass('expand');
    }, 200);
    if(breakpoint.value == 'xs'){
      $('body').css('overflow', 'hidden');
    }
    return true;
  }

  function closeFilterMenu(){
    $('#select').removeClass('expand opacity');
    $('#expandFilters img').removeClass('expand');
    setTimeout(function() {
      $('#filters').removeClass('shadow');
    }, 500);
    if(breakpoint.value == 'xs'){
      $('body').css('overflow', 'auto');
      setTimeout(function() {
        $("html, body").animate({ scrollTop: $('#filters').offset().top }, 'slow');
      }, 500);
    }
    return false;
  }

  /**
  * update  countries buttons' statuses in accordance to selected regions
  * regions checkboxes can activate or deactivate countries buttons
  */
  function updateCountriesButtonsStatuses(){
    setTimeout(function () {
      var countriesStatus = {};
      //- which countries has selected regions?
      $.each(countriesList, function (key, country) {
        countriesStatus[country] = false;
        $('.regions .country ul.' + country + ' input').each(function(){
          if( $(this).prop('checked') ){
            countriesStatus[country] = true;
          }
        });
      });
      //- apply status to countries buttons
      $.each(countriesStatus, function(country, status){
        if(status == true){
          $('#countries a#' + country).addClass('checked');
        }else{
          $('#countries a#' + country).removeClass('checked');
        }
      });
    }, "200");
  }

  function updateIndustriesButtonStatuses(){
    var allIndustriesStatus = true;

    $('.sectors .industries input:not(:disabled)').each(function(){
      if( !$(this).prop('checked') ){
        allIndustriesStatus = false;
      }
    });

    if(allIndustriesStatus){
      $('#sectors a#all-industries').addClass('checked');
    } else{
      $('#sectors a#all-industries').removeClass('checked');
    }
  }

  /**
  * set "disabled" status if there's no region or industry selected
  */
  function setApplyButtonStatus(selection) {
    if (selection.length) {
      $('#apply').removeClass('disabled');
    } else {
      $('#apply').addClass('disabled');
    }
  }

  /**
  * ON RESIZE
  */
  $(window).on('resize', function(){
    //- wait for end of resize
    setTimeout(function() {
      if(breakpoint.value != 'xs'){
        forceFlexWidthtoFitContent('.selections .regions:not(.mobile, .hidden) .country ul, .selections .sectors:not(.mobile, .hidden) ul');
        $('body').css('overflow', 'auto');
      }
      if(breakpoint.value == 'xs' && expandFilters == true){
        $('body').css('overflow', 'hidden');
      }
    }, "300");
  });

  /**
  * ON LOAD
  */
  $(function() {
    //- set widths of filters>regions & sectors
    if(breakpoint.value != 'xs'){
      forceFlexWidthtoFitContent('.selections .regions:not(.mobile) .country ul, .selections .sectors:not(.mobile) ul');
      $('#sectors-btn').parent().removeClass('large').addClass('medium');
    }
    //- then hide sectors + sectors menu
    $('.selections .sectors').addClass('hidden');
    $('ul#sectors').hide();

    /**
    * on #countries  change
    * update regions and sectors list according to countries selection
    */
    $('#countries a').on('click', function(){
      $(this).toggleClass('checked');
      $('nav #industries').addClass('checked');
      var selectedCountries = getCountriesSelection();
      var selectedRegions = updateRegions(selectedCountries);
      updateSectors(selectedCountries, selectedRegions);
    });
    /**
   * when .regions selection change
   * update sectors list and countries buttons
   *
   */
    $('.regions input').on('change', function(){
      updateCountriesButtonsStatuses();
      setTimeout(function() {
        var selectedCountries = getCountriesSelection();
        var selectedRegions = getRegionsSelection(selectedCountries);
        updateSectors(selectedCountries, selectedRegions);
      }, "300");
    });

    /**
   * when .sectors selection change
   * update projects list
   */
    $('.sectors input').on('change', function (){
      var selectedCountries = getCountriesSelection();
      getRegionsSelection(selectedCountries);
      getSectorsSelection();
      updateIndustriesButtonStatuses();
    });

    /**
   * updates map and loads cards
   */
    $('#apply').on('click', function(e){
      e.preventDefault();
      if( !$(this).hasClass('disabled') ){
        var selectedCountries = getCountriesSelection();
        var selectedRegions = getRegionsSelection(selectedCountries);
        var selectedSectors = getSectorsSelection();
        selectedProjects = getSelectedProjects(selectedCountries, selectedRegions, selectedSectors);
        if(breakpoint.value == 'xs'){
          expandFilters = closeFilterMenu();
        } else {
          $("html, body").animate({ scrollTop: $('#map').offset().top - 48}, 'slow');
        }
      }
    });

    /**
   * FILTERS DRAWER BEHAVIOUR
   */
    $('#expandFilters').on('click', function(e){
      e.preventDefault();
      $("html, body").animate({ scrollTop: $('#filters').offset().top }, 'fast');
      if(!expandFilters){
        expandFilters = expandFilterMenu();
      } else {
        expandFilters = closeFilterMenu();
      }
    });

    //- behaviour on click on first level filters' menu items
    $('#locations-btn, #sectors-btn').on('click', function (e) {
      e.preventDefault();
      // var target = '.' + $(this).attr('data-target');
      $('#locations-btn, #sectors-btn').find('img').toggleClass('active');

      $('#locations-btn, #sectors-btn').toggleClass('active');
      $('#locations-btn, #sectors-btn').parents('.locations, .sectors').toggleClass('active');
      $('.selections .regions, .selections .sectors').toggleClass('hidden');
      if(breakpoint.value != 'xs'){
        $('ul#countries, ul#sectors').slideToggle('fast');
      } else{
        $('ul#countries, ul#sectors').toggle();
      }
      //- reapply bug fix, needed after resize for dom elements who was hidden during resize
      forceFlexWidthtoFitContent('.selections .regions:not(.mobile, .hidden) .country ul, .selections .sectors:not(.mobile, .hidden) ul');
    });

    //- click on menu countries' buttons = horizontally scrolls to targeted country
    $('nav #countries a').on('click', function (e) {
      e.preventDefault();
      if (breakpoint.value !== 'xs') {
        var target = '.regions:not(.mobile) .country.' + $(this).attr('id');
        var position = Math.floor($('.regions:not(.mobile)')[0].scrollLeft);
        var offset = Math.floor($(target).position().left + position - 80);
        $('.regions:not(.mobile)').animate({ scrollLeft: offset }, 'fast');
      } else {
        var target = '.regions.mobile .country.' + $(this).attr('id');
        var position = Math.floor($('.regions.mobile').parent('.selections').scrollTop());
        var offset = Math.floor($(target).position().top + position);
        $('.selections.mobile').animate({ scrollTop: offset }, 'fast');
      }
    });

    $('nav #all-industries').on('click', function (e) {
      e.preventDefault();
      if($(this).hasClass('checked')){
        $('.selections .sectors input:not(:disabled)').each(function(){
          $(this).prop('checked', false);
        });
        $(this).removeClass('checked');
      } else {
        $('.selections .sectors input:not(:disabled)').each(function(){
          $(this).prop('checked', true);
        });
        $(this).addClass('checked');
      }
      getSectorsSelection();
    });
  });

}

